@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if (huur.length > 0) {
      <div formArrayName="huur">
        @for (item of huur.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Bedrag' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRijHuur(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRijHuur()" class="snelstart-ui-button" icon="plus"
                       type="link">Huurinkomsten toevoegen
  </snelstart-ui-button>

  <form [formGroup]="formGroup" class="pt-2">
    @if (kosten.length > 0) {
      <div formArrayName="kosten">
        @for (item of kosten.controls; track item; let i = $index) {
          <div [formGroupName]="i">
            <div class="row col-auto" style="--bs-gutter-x: 0.5rem;">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Omschrijving' : ''"
                                              class="custom-input-250"
                                              formControlName="omschrijving"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Bedrag' : ''"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="bedrag"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
              <snelstart-ui-button (click)="verwijderRijKosten(i)"
                                   [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                   icon="trash"
                                   iconType="light"
                                   id="buttonDeleteKosten"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>
  <snelstart-ui-button (click)="addRijKosten()" class="snelstart-ui-button" icon="plus"
                       type="link">Kosten toevoegen
  </snelstart-ui-button>
}
